import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FriendsWidget from '../HomePage/FriendsWidget';
import PostsWidget from '../HomePage/PostsWidget';
import UserWidgets from '../HomePage/UserWidgets';
import Navbar from '../Navbar/Navbar';

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const { userId } = useParams();
  const {token} = useSelector((state) => state.app);
  const getUser = async () => {
    const response = await fetch(`https://thoughtful-erin-oyster.cyclic.app/users/${userId}`, {
      method: "GET",
      headers: { authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    setUser(data);
  };
  useEffect(() => {
    getUser();
  }, [userId]);// eslint-disable-line react-hooks/exhaustive-deps

  if (!user) return null;

  return (
    <div className='w-full flex flex-col gap-6 dark:bg-[#3D3B3B] '>
        <Navbar/>
        <div className='w-full flex xs:flex-col xs:items-center justify-center gap-6 pl-6 pr-6'>
          <div className='flex flex-col w-[25%] gap-2 xs:w-full min-w-min xs:max-w-[500px] ' >
          <UserWidgets userId={userId} picturePath={user.picturePath}/>
          </div>
          <div className='w-[40%] xs:w-full xs:max-w-[500px] min-w-min flex flex-col'>
          <PostsWidget userId={userId} isProfile/>
          </div>
          <div className=" w-[25%] xs:w-full xs:max-w-[500px] flex flex-col xs:items-center gap-4 sm:sticky">
            <FriendsWidget userId={userId} />
          </div>            
        </div>
    </div>
  )
}

export default ProfilePage